import { CustomPropertiesProvider } from './CustomPropertiesProviderHttpBoundConnector'

export default {
  __init__: ['customSelectPropertiesProvider'],
  customSelectPropertiesProvider: ['type', CustomPropertiesProvider],
}
